import { IPagedResultset, IResponseBase } from "./app";
import { IStaff } from "./staff";

export enum UserRoles {
  Tech = 0,
  Shopman = 10,
  Salesman = 20,
  Admin = 30,
  InShopTech = 40
}

export interface IRoleItem {
  value: UserRoles;
  text: string;
}

export const ROLES_LIST: IRoleItem[] = [
  {
    value: 0,
    text: "Field Tech"
  },
  {
    value: 40,
    text: "In-Shop Tech"
  },
  {
    value: 10,
    text: "Shopman"
  },
  {
    value: 20,
    text: "Salesman"
  },
  {
    value: 30,
    text: "Admin"
  }
];

export interface IPath {
  Name: string;
  Link: string;
}

export interface IWhoAmI {
  UserID: number;
  Roles: UserRoles[];
  FName: string;
  LName: string;
	Gravatar: string;
	PpwDealership: number;
	PpwRetail: number;
	IsActive: boolean;
}

export interface IUser {
  RecordID?: number;
  FName: string;
  LName: string;
  Email: string;
  Phone: string;
  Mobile: string;
  Initials: string;
  IsActive: boolean;
  IsRep: boolean;
  Username: string;
  Password?: string;
	Roles: UserRoles[];
	RimRepairListID: string;
	BentRepairListID: string;
}

export interface IUserAndPrices{
	User: IUser;
	Prices: ITechPrice[];
}



export interface ITechPrice 
{
	RecordID: number;
	TechID: number;
	ServiceID: number;
	Ppw: number;
}




export interface IUserResponseData extends IPagedResultset {
  Users: IUser[];
}

export interface ISearchUserRequest {
  Keyword: string;
	ActiveOnly?: boolean;
  Page?: number;
  PageSize?: number;
}

export interface ISearchUserResponse extends IResponseBase {
  Results: IUserResponseData;
}

export interface IGetUserRolesRequest {
  UserID: number;
}

export interface IGetUserRolesResponse extends IResponseBase {
  Roles: UserRoles[];
}

export interface ISetUserRolesRequest {
  UserID: number;
  Roles: UserRoles[];
}

export interface ISetUserRolesResponse extends IResponseBase {
  Roles: UserRoles[];
}

export interface IChangeUserStatusRequest {
  UserID: number;
  IsActive: boolean;
}

export interface IChangeUserStatusResponse extends IResponseBase 
{
	 User:IStaff;
}

export interface IChangeUserPassRequest {
  UserID: number;
  CurrPass: string;
  NewPass: string;
}

export interface IChangeUserPassResponse extends IResponseBase {}

export interface IChangeUserEmailRequest {
  UserID: number;
  NewEmail: string;
}

export interface IChangeUserEmailResponse extends IResponseBase {}

export interface IInsertUserRequest {
  User: IUser;
}


export interface IInsertUserResponse extends IResponseBase {
  UserID: number;
	User: IStaff
}

export interface IUpdateUserRequest {
  User: IUser;
}

export interface IUpdateUserResponse extends IResponseBase {
	User: IStaff;
}

export interface IGetUserRequest {
  UserID: number;
}

export interface IGetUserResponse extends IResponseBase {
  User: IUser;
	TechPrices: ITechPrice[];
}

export interface IGetTechPricesRequest {
  TechID: number;
}

export interface IGetTechPricesResponse extends IResponseBase {
  TechPrices: ITechPrice[];
}

export interface IUpdateTechPricesRequest {
	TechID: number;
  TechPrices: ITechPrice[];
}

export interface IUpdateTechPricesResponse extends IResponseBase {
}


